import React from "react";
import { Tag, Inbox, Stats, Settings as SettingsIconSvg } from "react-ikonate";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import Card from "shared/Card";
import { Auth } from "shared/@auth/Auth";
import isDevEnvironment from "shared/@utils/isDevEnvironment";
import isQaModeEnabled from "shared/@utils/isQaModeEnabled";
import Page, { Content, Nav, NavGroup, NavItem } from "shared/Page";
import Store from "./Store";
import Settings from "./Settings";
import OrderManagement from "./OrderManagement";
import Promotions from "./Promotions";
import Statistics from "./Statistics";
import WBagIcon from "./assets/WBagIcon";
import MockDataBadge from "./components/MockDataBadge";
import QaModeBadge from "./components/QaModeBadge";

export function BSM() {
  const { path } = useRouteMatch();
  const { hasPermission } = Auth.useContainer();
  const isDev = isDevEnvironment();
  // Promotions is Rev 2: the catalog reads real data but there is no create or
  // edit path yet, and no discount system for it to feed. Keep it out of
  // production until Rev 2. Order Management, Statistics and Settings all ship
  // in Rev 1, so they are gated on permission alone.
  const showRev2Sections = isDev || isQaModeEnabled();

  return (
    <>
      <Page>
        <Nav>
          <NavGroup title="WWG Store">
            {hasPermission("bsm.*") && (
              <NavItem to={`${path}/home`} icon={<WBagIcon />}>
                Store
              </NavItem>
            )}

            {hasPermission("bsm.*") && (
              <NavItem to={`${path}/order-management`} icon={<Inbox />}>
                Order Management
              </NavItem>
            )}
            {hasPermission("bsm.*") && showRev2Sections && (
              <NavItem to={`${path}/promotions`} icon={<Tag />}>
                Promotions
              </NavItem>
            )}
            {hasPermission("bsm.*") && (
              <NavItem to={`${path}/statistics`} icon={<Stats />}>
                Statistics
              </NavItem>
            )}
            {hasPermission("bsm.*") && (
              <NavItem to={`${path}/settings`} icon={<SettingsIconSvg />}>
                Settings
              </NavItem>
            )}
          </NavGroup>
        </Nav>
        <Content>
          <Switch>
            {hasPermission("bsm.*") && (
              <Route path={`${path}/home`}>
                <Card>
                  <Store />
                </Card>
              </Route>
            )}

            {hasPermission("bsm.*") && (
              <Route path={`${path}/order-management`}>
                <Card>
                  <OrderManagement />
                </Card>
              </Route>
            )}

            {/* Promotions is Rev 2 — gate the route the same way as its nav
                  entry so it isn't deep-linkable in production. */}
            {hasPermission("bsm.*") && showRev2Sections && (
              <Route path={`${path}/promotions`}>
                <Card>
                  <Promotions />
                </Card>
              </Route>
            )}

            {hasPermission("bsm.*") && (
              <Route path={`${path}/statistics`}>
                <Card>
                  <Statistics />
                </Card>
              </Route>
            )}

            {hasPermission("bsm.*") && (
              <Route path={`${path}/settings`}>
                <Card>
                  <Settings />
                </Card>
              </Route>
            )}

            <Route path="*">
              <Redirect to={`${path}/home`} />
            </Route>
          </Switch>
        </Content>
      </Page>
      <MockDataBadge />
      <QaModeBadge />
    </>
  );
}
